<template>
  <v-tooltip bottom :allow-overflow="true">
    <template v-slot:activator="{ on, attrs }">
      <v-icon v-bind="attrs" v-on="on" size="22" :class="iconColor">{{iconName}}</v-icon>
    </template>
    <span>{{ statusText }}</span>
  </v-tooltip>
</template>

<script>
  export default {
    name: "LogIcon",

    props: ['status', 'statusText'],

    computed: {
      iconName: function () {
        switch (this.status) {
          case 1:
            return 'mdi-check-circle';
          case 2:
            return 'mdi-alert-circle';
          default:
            return 'mdi-timer-outline';
        }
      },
      iconColor: function () {
        switch (this.status) {
          case 1:
            return 'teal--text';
          case 2:
            return 'deep-orange--text text--accent-4';
          default:
            return '';
        }
      },
    },
  };
</script>
